<template>
  <a
    class="navbar-item app-logo-button"
    href="/"
    style="background-color: white"
  >
    <img
      src="./../../public/slashmap_logo_small.png"
      alt="SlashMap | Slack plugin for finding locations around the office"
      class="app-logo"
    />
  </a>
</template>

<script>
export default {
  name: "app-logo"
};
</script>

<style scoped>
.app-logo {
  max-height: 40px;
  width: auto;
}
.app-logo:hover {
  background-color: white;
  color: white;
}
.app-logo-button {
  padding-left: 0px;
}
@media (max-width: 768px) {
  .app-logo-button {
    margin: auto;
    padding: 0;
  }
}
.app-logo-button:hover {
  background-color: white;
  color: white;
}
</style>
